<template>
	<el-dialog v-dialogDrag :title="mergeData.title" :visible.sync="show" width="720px" :close-on-click-modal="false">
		<div class="merge-forward-dialog">
			<el-scrollbar class="message-list">
				<div class="message-item" v-for="(msg, index) in mergeData.messages" :key="index">
					<chat-history-item :headImage="msg.sendHeadImage" :showName="msg.sendNickName" :msgInfo="msg">
					</chat-history-item>
				</div>
			</el-scrollbar>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="close()">取 消</el-button>
			<el-button type="primary" @click="close()">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
import HeadImage from '../common/HeadImage.vue';
import ChatHistoryItem from './ChatHistoryItem.vue';

export default {
	name: "ChatMergeForward",
	components: {
		HeadImage,
		ChatHistoryItem
	},
	data() {
		return {
			show: false,
			mergeData: {}
		}
	},
	methods: {
		open(mergeData) {
			this.mergeData = mergeData;
			this.show = true;
		},
		close() {
			this.show = false;
		},
		formatTime(timestamp) {
			return this.$date.toTimeText(timestamp);
		},
		contentData(msgInfo) {
			return JSON.parse(msgInfo.content)
		},
		htmlText(msgInfo) {
			let text = this.$str.html2Escape(msgInfo.content)
			text = this.$url.replaceURLWithHTMLLinks(text, '')
			return this.$emo.transform(text, 'emoji-normal')
		}
	}

}
</script>

<style lang="scss" scoped>
.merge-forward-dialog {
	.message-list {
		padding: 0 15px;
		height: 500px;

		.message-item {
			padding-bottom: 15px;
			border-bottom: 0.5px solid var(--hairline-soft);
		}
	}
}
</style>
